<template>
    <div class="row hm-calendar-container">
        <div class="col-12">
            <div class="card border-0">
                <div class="card-body p-0">
                    <div class="d-flex justify-content-between p-3">
                        <div class="d-flex align-items-center gap-2">
                            <SquareArrowLeft @click="getPreviousData" class="cursor-pointer"/>
                            <SquareArrowRight @click="getNextData" class="cursor-pointer" />
                            <template v-if="weekOptions.includes(searchType)">
                                {{formattedDate(startOfWeek,"DD MMM YYYY").toUpperCase()}}
                                -
                                {{formattedDate(endOfWeek,"DD MMM YYYY").toUpperCase()}}
                            </template>
                            <template v-else-if="monthOptions.includes(searchType)">
                                {{formattedDate(currentMonth,"MMM YYYY").toUpperCase()}}
                            </template>

                            <!-- <i @click="getPreviousData" class="bi bi-chevron-left cursor-pointer fs-5"></i>
                            <i @click="getNextData" class="bi bi-chevron-right cursor-pointer fs-5"></i> -->
                        </div>
                        <div class="d-flex align-items-center gap-2">
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-theme ms-2 text-nowrap"
                                v-text="displayMap ? 'View Calendar' : 'View Map'"
                                @click="displayMap= !displayMap"
                            ></button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-success ms-2 text-nowrap"
                                @click="downloadDueDateServices"
                            >Download CSV</button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                @click="searchType='this_month'"
                            >Reset</button>
                            <div class="hm-db--date-filter">
                                <Select2
                                    v-model="searchType"
                                    :options="[{id: 'this_week', text: 'This Week'}, {id: 'next_week', text: 'Next Week'}, {id: 'this_month', text: 'This Month'}]"
                                    :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Filter Order' }"
                                />
                            </div>
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Search Task"
                                v-model="searchTerm"
                            >
                        </div>
                    </div>
                </div>
                <div class="card-body p-0 border-0">
                    <!--<div
                        class="hm-due-date-table"
                        :class="{ 'overflow-auto': monthOptions.includes(searchType) }"
                        :style="{ height: screenHeight + 'px' }"
                    >-->
                    <div v-if="displayMap">
                        <google-map :orders="dueDateServices"></google-map>
                    </div>
                    <div v-else class="hm-due-date-table">
                        <!-- Display monthly data -->
                        <table class="table table-bordered mb-0">
                            <thead class="due-date-table-head">
                                <tr>
                                    <td v-for="(week, index) in weekDays" :key="index" class="text-center">
                                        {{ week.day }}
                                        <div v-if="weekOptions.includes(searchType)" class="fs-6">
                                            {{ week.date }}/{{ week.year }}
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="weekOptions.includes(searchType)">
                                    <td
                                        v-for="(week, index) in weekDays"
                                        :key="index"
                                        :class="{'disabled-day': !isScheduleAvailable(week.date) }"
                                    >
                                        <div
                                            class="mx-auto align-middle order-item-container"
                                        >
                                            <draggable
                                                v-model="dueDateServices"
                                                v-bind="dragOptions"
                                                group="people"
                                                :item-key="'calender'"
                                                :component-data="{
                                                    due_date: week.date,
                                                }"
                                                @start="startDrag"
                                                :move="onMove"
                                                @end="endDrag"
                                                @change="onChangeItem"
                                            >
                                                <template #item="{ element }">
                                                    <div
                                                        v-if="element.day_of_month == week.date"
                                                        class="hm-service-card task-dashboard-container p-2 mb-1 rounded order-list-group-item hm-fs-11"
                                                        :class="getRandomClass()"
                                                        @contextmenu.prevent.stop="taskItemClick($event,element)"
                                                    >
                                                        <div class="d-flex justify-content-between pt-1">
                                                            <label class="hm-service-name text-black">{{ $truncateString(element.service_name, 30) }}</label>
                                                        </div>
                                                        <div class="d-flex justify-content-between pt-1">
                                                            <label class="order-client-name">{{ $truncateString(element.address, 40) }}</label>
                                                            <label
                                                                v-if="element.postal_code != ''"
                                                                class="order-client-postcode text-nowrap px-1 rounded-1"
                                                            >
                                                                <span>{{ element.postal_code }}</span>
                                                            </label>
                                                        </div>
                                                        <div class="d-flex justify-content-between pt-1">
                                                            <label class="order-client-name">
                                                                {{ $truncateString(element.customer_full_name, 20) }}
                                                                <div v-if="element.acp_full_name != ''" class="small">
                                                                    {{ $truncateString(element.acp_full_name, 20) }}
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <!-- Display order status -->
                                                        <div
                                                            v-if="element.order_number != '' && element.order_number != null"
                                                            class="pt-1 cursor-pointer"
                                                            @click="$goToPage(`/admin/orders/${element.order_number}`)"
                                                        >
                                                            <label class="badge bg-theme text-wrap text-capitalize">View Order</label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </draggable>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    v-else
                                    v-for="(week, index) in calendar"
                                    :key="index"
                                >
                                    <td
                                        v-for="day in week"
                                        :key="day.day"
                                        class=""
                                        :class="{ 'text-muted': day.day === '', 'disabled-day': !isScheduleAvailable(day.date) }"
                                    >
                                        <div class="task-dashboard-container hm-day-container">
                                            <div class="">{{ day.day }}</div>
                                            <!-- Iterate the due date services and display the service name -->
                                            <div class="mx-auto">
                                                <draggable
                                                    class="order-list-group"
                                                    v-model="dueDateServices"
                                                    v-bind="dragOptions"
                                                    group="people"
                                                    :item-key="'calender'"
                                                    :component-data="{
                                                        due_date: day.day,
                                                        date: day.date
                                                    }"
                                                    @start="startDrag"
                                                    :move="onMove"
                                                    @end="endDrag"
                                                    @change="onChangeItem"
                                                >
                                                    <template #item="{ element }">
                                                        <div
                                                            v-if="element.day_of_month == day.day"
                                                            class="hm-service-card task-dashboard-container p-2 mb-1 rounded order-list-group-item hm-fs-11"
                                                            :class="getRandomClass()"
                                                            @contextmenu.prevent.stop="taskItemClick($event,element)"
                                                        >
                                                            <div class="d-flex justify-content-between pt-1">
                                                                <label class="hm-service-name text-black">{{ $truncateString(element.service_name, 30) }}</label>
                                                            </div>
                                                            <div class="d-flex justify-content-between pt-1">
                                                                <label class="order-client-name">{{ $truncateString(element.address, 40) }}</label>
                                                                <label
                                                                    v-if="element.postal_code != ''"
                                                                    class="order-client-postcode text-nowrap px-1 rounded-1"
                                                                >
                                                                    <span>{{ element.postal_code }}</span>
                                                                </label>
                                                            </div>
                                                            <div class="d-flex justify-content-between pt-1">
                                                                <label class="order-client-name">
                                                                    {{ $truncateString(element.customer_full_name, 20) }}
                                                                    <div v-if="element.acp_full_name !=''" class="small">
                                                                        {{ $truncateString(element.acp_full_name, 20) }}
                                                                    </div>
                                                                </label>
                                                            </div>
                                                            <!-- Display order status -->
                                                            <div
                                                                v-if="element.order_number != '' && element.order_number != null"
                                                                class="pt-1 cursor-pointer"
                                                                @click="$goToPage(`/admin/orders/${element.order_number}`)"
                                                            >
                                                                <label class="badge bg-theme text-wrap text-capitalize">View Order</label>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </draggable>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- right click context -->
    <vue-simple-context-menu
        element-id="myFirstMenu"
        :options="taskOptions"
        ref="taskItemContext"
        @option-clicked="taskItemMenuAction"
    >
    </vue-simple-context-menu>

    <!-- Assign order to handyman modal dialog -->
    <div
        class="modal fade"
        id="assignOrderModal"
        tabindex="-1"
        data-backdrop="static"
        data-keyboard="false"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <div class="modal-header">
                    <h5 class="modal-title">Create Order</h5>
                </div>
                <div class="modal-body">
                    <form class="row g-3">
                        <div class="col-md-4">
                            <label for="customer_name" class="form-label"
                                >Client Name</label
                            >
                            <input
                                type="text"
                                class="form-control disabled"
                                id="customer_name"
                                disabled
                                v-model="assignOrderData.customer_full_name"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="phone_number" class="form-label"
                                >Mobile Number</label
                            >
                            <input
                                type="text"
                                class="form-control disabled"
                                id="phone_number"
                                disabled
                                v-model="
                                    assignOrderData.customer_phone_number
                                "
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="email" class="form-label"
                                >Email</label
                            >
                            <input
                                type="text"
                                class="form-control disabled"
                                id="email"
                                disabled
                                v-model="assignOrderData.customer_email"
                            />
                        </div>
                        <div class="col-md-12">
                            <label for="email" class="form-label"
                                >Address</label
                            >
                            <textarea
                                class="form-control disabled"
                                id="email"
                                rows="1"
                                disabled
                                v-model="assignOrderData.full_address"
                            ></textarea>
                        </div>
                        <hr/>
                        <div class="col-md-6">
                            <label for="assign_date" class="form-label">Allocation Date <span class="text-danger">*</span></label>
                            <BookingDatePicker
                                v-model="assignOrderData.order_booking_date"
                                :format="'dd-MM-yyyy'"
                                :time-picker="false"
                            ></BookingDatePicker>
                        </div>
                        <div class="col-md-6">
                            <label for="assign_date" class="form-label">Order Time <span class="text-danger">*</span></label>
                            <VueDatePicker
                                v-model="assignOrderData.order_booking_time"
                                time-picker :is-24="false"
                                :clearable="false"
                                :minutes-grid-increment="10"
                                :minutes-increment="15"
                            >
                                <template #input-icon>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                </template>
                            </VueDatePicker>
                        </div>
                        <div class="col-md-6">
                            <div class="form-check form-check-inline pb-1">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="assign_duration"
                                    id="hours"
                                    value="hours"
                                    v-model="assignOrderData.assigned_duration_type"
                                >
                                <label class="form-check-label" for="hours">Time Duration (In Hours)</label>
                            </div>
                            <div class="form-check form-check-inline pb-1">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="assign_duration"
                                    id="full_day"
                                    value="full_day"
                                    v-model="assignOrderData.assigned_duration_type"
                                >
                                <label class="form-check-label" for="full_day">Full Day</label>
                            </div>
                            <input
                                type="number"
                                class="form-control"
                                id="assign_duration"
                                :class="{'disabled': assignOrderData.assigned_duration_type === 'full_day'}"
                                :disabled="assignOrderData.assigned_duration_type === 'full_day'"
                                v-model="assignOrderData.assigned_duration"
                            />
                        </div>
                        <!-- <div class="col-md-6">
                            <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                            <Select2
                                v-model="assignOrderData.handyman_id"
                                :options="handymanOptions"
                                :settings="{
                                    multiple: true,
                                    placeholder: 'Select Handyman',
                                    dropdownCssClass: 'assign-handyman-dropdown',
                                    selectionCssClass: 'hm-multiselect'
                                }"
                            />
                            <small v-if="handymanOptions.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                        </div> -->
                    </form>
                </div>
                <div class="modal-footer">
                    <a
                        type="button"
                        class="text-theme pe-3"
                        data-bs-dismiss="modal"
                        @click="cancelItemDrop"
                    >Cancel</a>
                    <button
                        type="button"
                        class="btn btn-theme btn-sm"
                        v-text="isLoading ? 'Loading...' : 'Create Order'"
                        @click="assignOrder"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import Select2 from "vue3-select2-component";
import draggable from "vuedraggable";
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import BookingDatePicker from "./BookingDatePicker";
import GoogleMap from "./GoogleMap";
import { appMixin } from '../mixin/appMixin';
import {
    SquareArrowRight,
    SquareArrowLeft,
} from "lucide-vue-next";

export default {
    mixins: [appMixin],
    components: {
        draggable,
        Select2,
        VueSimpleContextMenu,
        BookingDatePicker,
        GoogleMap,
        SquareArrowRight,
        SquareArrowLeft,
    },
    data() {
        return {
            isLoading: false,
            enggDocReady: false,
            drag: false,
            displayType: "month", // day, week, month
            selectedDate: moment(),
            weekDays: [],
            calendar: [],
            handymanOptions: [],
            startOfWeek: "",
            endOfWeek: "",
            currentWeek: "",
            currentMonth: "",
            taskOptions: [{ name: "Create Order", job: "assign-order" }],
            assignOrderData: {},
            dueDateServices: [],
            screenHeight: "",
            draggedContext: {},
            relatedContext: {},
            searchType: 'this_month',
            searchTerm: '',
            handymanSchedules: [],
            weekOptions: ['this_week', 'next_week', 'custom_week'],
            monthOptions: ['this_month', 'next_month' , 'custom_month'],
            displayMap: false,
            startDate: '',
            endDate: '',
        };
    },
    created() {
        // Prepare current week
        this.startOfWeek = moment().startOf("isoWeek");
        this.endOfWeek = moment().endOf("isoWeek");
        this.currentWeek = this.startOfWeek + " - " + this.endOfWeek;

        // Prepare current month
        this.currentMonth = moment();
        this.getHandymanUsers();
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    mounted() {
        this.screenHeight = window.innerHeight - 150;

        window.addEventListener("resize", () => {
            this.screenHeight = window.innerHeight - 150;
        });

        this.preparedWeekDays();
        this.generateCalendar();

        // Get handyman schedules
        this.getHandymanSchedules();
    },
    methods: {
        cancelItemDrop() {
            $("#assignOrderModal").modal("hide");
        },
        assignOrder() {
            this.isLoading = true;
            /* if(typeof this.assignOrderData.handyman_id === 'undefined' ||this.assignOrderData.handyman_id.length === 0) {
                this.$notification('error', "Please assign at-least one handyman to the order.");
                this.isLoading = false;
                return;
            } */
            const data = this.assignOrderData;
            axios
                .post("/admin/orders/create-and-assign", data)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.enggDocReady = false;
                        this.isLoading = false;
                        this.getDueDateServices();
                        $("#assignOrderModal").modal("hide");
                    }
                    this.$notification(response.data.status, response.data.message);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getHandymanUsers() {
            let self = this;
            axios.post("/admin/users/get-handyman-users")
                .then((response) => {
                    self.handymanUsers = response.data.users;

                    // Get id and name of users and push into the userOptions
                    self.handymanOptions = [{ id: " ", text: "Select Handyman" }];
                    response.data.users.forEach((user) => {
                        self.handymanOptions.push({
                            id: user.id,
                            text: user.full_name,
                        });
                    });
                });
        },
        formatDate(date, format) {
            return moment(date).format(format);
        },
        taskItemMenuAction(event) {
            if (event.option.job === "assign-order") {
                const item = event.item;
                this.assignOrderData = item;
                this.assignOrderData.booking_date = this.formatDate(item.due_date,"YYYY-MM-DDTHH:mm");
                this.assignOrderData.order_booking_date = this.formatDate(item.due_date,"YYYY-MM-DD");
                //this.assignOrderData.order_booking_time = { hours: this.formatDate(item.due_date, "HH"), minutes: this.formatDate(item.due_date, "mm") };
                this.assignOrderData.order_booking_time = { hours: '07', minutes: '00' };
                this.assignOrderData.assigned_duration = 1;

                // Prepare assign_duration_type
                // Check if assign_duration is 8 then mark full day
                if (item.assigned_duration === 8) {
                    this.assignOrderData.assigned_duration_type = "full_day";
                }
                else {
                    this.assignOrderData.assigned_duration_type = "hours";
                }

                $("#assignOrderModal").modal({
                    backdrop: "static",
                    keyboard: false,
                });
                $("#assignOrderModal").modal("show");
                return false;
            }
            else if (event.option.job === "view-order") {
                const item = event.item;
                this.$goToPage(`/admin/orders/${item.order_number}`);
            }
        },
        taskItemClick(event, item) {
            // Check if status is available then not show the menu
            if(item.order_number != '' && item.order_number != null) {
                this.taskOptions = [{ name: "View Order", job: "view-order" }];
            }
            else {
                this.taskOptions = [{ name: "Create Order", job: "assign-order" }];
            }
            this.$refs.taskItemContext.showMenu(event, item);
        },
        startDrag() {
            console.log("changed");
            this.drag = true;
        },
        endDrag(event) {
            console.log("fdfdf");
            this.drag = false;
        },
        onMove({ relatedContext, draggedContext }) {
            this.draggedContext = draggedContext;
            this.relatedContext = relatedContext;
            return true;
        },
        onChangeItem(event) {
            axios
                .post("/admin/due-dates/update-due-date-services", {
                    recursive_id: this.draggedContext.element.id,
                    due_date: this.formattedDate(
                        this.currentMonth.format("YYYY-MM-") +
                            this.relatedContext.component.componentData
                                .due_date,
                        "YYYY-MM-DD"
                    ),
                })
                .then((response) => {
                    this.getDueDateServices();
                })
                .catch((error) => {
                    console.log(error);
                });
            return true;
        },
        formattedDate(date, format) {
            return moment(date).format(format);
        },
        getDueDateServices() {
            let self = this;

            let startDate = '';
            let endDate = '';

            if (this.searchType === 'today') {
                startDate = moment().format('YYYY-MM-DD');
                endDate = moment().format('YYYY-MM-DD');
            }
            else if(this.searchType === 'tomorrow') {
                startDate = moment().add(1, 'days').format('YYYY-MM-DD');
                endDate = moment().add(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'yesterday') {
                startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_week') {
                startDate = moment().startOf('week').format('YYYY-MM-DD');
                endDate = moment().endOf('week').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'next_week') {
                startDate = moment().add(1, 'week').startOf('week').format('YYYY-MM-DD');
                endDate = moment().add(1, 'week').endOf('week').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_week') {
                startDate = moment(this.startOfWeek).format('YYYY-MM-DD');
                endDate = moment(this.endOfWeek).format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_month') {
                startDate = moment().startOf('month').format('YYYY-MM-DD');
                endDate = moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'last_month') {
                startDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_month') {
                startDate = moment(this.currentMonth).startOf('month').format('YYYY-MM-DD');
                endDate = moment(this.currentMonth).endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_year') {
                startDate = moment().startOf('year').format('YYYY-MM-DD');
                endDate = moment().endOf('year').format('YYYY-MM-DD');
            }

            axios
                .post("/admin/due-dates/get-due-date-services", {
                    display_type: this.displayType,
                    start_of_week: this.startOfWeek,
                    end_of_week: this.endOfWeek,
                    month: this.currentMonth.format("YYYY-MM"),
                    start_date: startDate,
                    end_date: endDate,
                    search_term: this.searchTerm,
                    search_type: this.searchType
                })
                .then((response) => {
                    self.dueDateServices = response.data.services;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        generateCalendar() {
            const currentDate = this.currentMonth;
            const year = currentDate.year();
            const month = currentDate.month();
            const firstDayOfMonth = moment([year, month, 1]).day(); // Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
            const daysInMonth = currentDate.daysInMonth();

            const prevMonthDays = (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); // Adjusting for Monday as the first day of the week
            //const prevMonthDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth;
            const totalDays = prevMonthDays + daysInMonth;

            const calendar = [];
            let dayCounter = 1;

            for (let i = 0; i < 6; i++) {
                const week = [];
                for (let j = 0; j < 7; j++) {
                    if (i === 0 && j < prevMonthDays) {
                        week.push({ day: "", date: "" });
                    } else if (dayCounter <= daysInMonth) {
                        // Create a moment object for the current day
                        const dayDate = moment([year, month, dayCounter]);
                        week.push({
                            day: dayCounter,
                            date: dayDate.format('YYYY-MM-DD') // Format the date as 'YYYY-MM-DD'
                        });
                        dayCounter++;
                    } else {
                        week.push({ day: "", date: "" });
                    }
                }

                // Check if the week contains any non-empty day
                if (week.some((item) => item.day !== "")) {
                    calendar.push(week);
                }
            }

            this.calendar = calendar;

            this.getDueDateServices();
        },
        preparedWeekDays() {
            const startDate = this.startOfWeek; // Start of the current week
            const endDate = this.endOfWeek; // End of the current week

            const currentDay = moment(startDate);
            const weekDays = [];

            while (currentDay.isSameOrBefore(endDate)) {
                weekDays.push({
                    year: currentDay.format("YY"),
                    date: currentDay.format("DD"),
                    day: currentDay.format("ddd"),
                });
                currentDay.add(1, "day");
            }

            this.weekDays = weekDays;
        },
        generateWeekCalendar() {
            this.preparedWeekDays();
            // Get the data from the database
            this.getDueDateServices();
        },
        getNextData() {
            this.searchType = (this.monthOptions.includes(this.searchType) ? 'custom_month' : 'custom_week');
            // Check if display type is day then add 1 day
            if (this.weekOptions.includes(this.searchType)) {
                this.startOfWeek = moment(this.startOfWeek).add(1, "weeks");
                this.endOfWeek = moment(this.endOfWeek).add(1, "weeks");
                this.currentWeek = this.startOfWeek + " - " + this.endOfWeek;

                this.generateWeekCalendar();
            } else if (this.monthOptions.includes(this.searchType)) {
                this.currentMonth = moment(this.currentMonth).add(1, "months");
                this.generateCalendar();
            }
        },
        getPreviousData() {
            this.searchType = (this.monthOptions.includes(this.searchType) ? 'custom_month' : 'custom_week');
            // Check if display type is day then subtract 1 day
            if (this.weekOptions.includes(this.searchType)) {
                this.searchType = 'custom_week';
                this.startOfWeek = moment(this.startOfWeek).subtract(1,"weeks");
                this.endOfWeek = moment(this.endOfWeek).subtract(1, "weeks");
                this.currentWeek = this.startOfWeek + " - " + this.endOfWeek;

                this.generateWeekCalendar();
            } else if (this.monthOptions.includes(this.searchType)) {
                this.searchType = 'custom_month';
                this.currentMonth = moment(this.currentMonth).subtract(1,"months");

                this.generateCalendar();
            }
        },
        getRandomClass() {
            let cardItemClasses = [
                "task-bg-green",
                "task-bg-light-green",
                "task-bg-purple",
                "task-bg-orange",
                "task-bg-warning",
                "task-bg-blue",
                "task-bg-default",
                "task-bg-pink",
            ];
            return cardItemClasses[
                Math.floor(Math.random() * cardItemClasses.length)
            ];
        },
        getHandymanSchedules() {
            let self = this;
            axios.post("/admin/handymans/get-hm-schedules")
                .then((response) => {
                    self.handymanSchedules = response.data.schedules;
                });
        },
        // Prepare handyman options from the schedules
        prepareHandymanOptions() {
            let self = this;
            self.handymanOptions = [];

            const dateToFind = this.formatDate(this.assignOrderData.booking_date, 'YYYY-MM-DD');
            const timeToFind =  moment(this.assignOrderData.booking_date, 'YYYY-MM-DD HH:mm:ss');

            Object.keys(this.handymanSchedules).forEach((handymanId) => {
                this.handymanSchedules[handymanId].forEach((schedule) => {
                    const startTime = moment(`${schedule.schedule_date} ${schedule.start_time}`, 'YYYY-MM-DD HH:mm:ss');
                    const endTime = moment(`${schedule.schedule_date} ${schedule.end_time}`, 'YYYY-MM-DD HH:mm:ss');

                    //if (schedule.schedule_date === dateToFind) {
                    if (schedule.schedule_date === dateToFind && timeToFind.isBetween(startTime, endTime,undefined, '[]')) {
                        let exists = self.handymanOptions.some(function(option) {
                            return option.id === schedule.handyman_id;
                        });
                        // If it doesn't exist, push the new option
                        if (!exists) {
                            self.handymanOptions.push({
                                id: schedule.handyman_id,
                                text: schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                            });
                        }
                    }
                });
            });
        },
        // Check if schedule is available for the given date
        isScheduleAvailable(date) {
            // First check if date is empty then return false
            if (!date) {
                return false;
            }

            const formattedDate = moment(date).format('YYYY-MM-DD');

            // Check if given date is less than current date then return false

            if (moment(formattedDate).isBefore(moment().format('YYYY-MM-DD'))) {
                return false;
            }
            // Use `Object.values()` to iterate over values of the `schedules` object
            // and `Array.prototype.some()` to check for at least one match.
            return Object.values(this.handymanSchedules).some(handymanSchedules =>
                handymanSchedules.some(schedule => schedule.schedule_date === formattedDate)
            );
        },
        prepareStartEndDate() {
            if (this.searchType === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            else if(this.searchType === 'tomorrow') {
                this.startDate = moment().add(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().add(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_week') {
                this.startDate = moment().startOf('week').format('YYYY-MM-DD');
                this.endDate = moment().endOf('week').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'next_week') {
                this.startDate = moment().add(1, 'week').startOf('week').format('YYYY-MM-DD');
                this.endDate = moment().add(1, 'week').endOf('week').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_week') {
                this.startDate = moment(this.startOfWeek).format('YYYY-MM-DD');
                this.endDate = moment(this.endOfWeek).format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_month') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'last_month') {
                this.startDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_month') {
                this.startDate = moment(this.currentMonth).startOf('month').format('YYYY-MM-DD');
                this.endDate = moment(this.currentMonth).endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_year') {
                this.startDate = moment().startOf('year').format('YYYY-MM-DD');
                this.endDate = moment().endOf('year').format('YYYY-MM-DD');
            }
        },
        downloadDueDateServices() {
            // Define CSV headers
            const headers = ['Customer Name', 'Customer Email', 'Customer Phone', 'Contact Person', 'Full Address', 'Postal Code', 'Service Name', 'Due Date'];
            // Create CSV content
            let csv = headers.join(',') + '\n';

            this.dueDateServices.forEach(service => {
                csv += `"${service.customer_full_name}","${service.customer_email}","${service.customer_phone_number}","${service.acp_full_name}","${service.full_address}","${service.postal_code}","${service.service_name}","${this.dataTimeFormat(service.due_date, 'DD/MM/YYYY')}"\n`;
            });

            // Create and trigger download
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'due_date_services.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    watch: {
        displayType(newVal, oldVal) {
            if (newVal === "week") {
                this.generateWeekCalendar();
            } else if (newVal === "month") {
                this.generateCalendar();
            }
        },
        searchType(newVal, oldVal) {
            if (['this_week', 'next_week'].includes(newVal)) {
                this.generateWeekCalendar();
            } else if (['this_month', 'next_month'].includes(newVal)) {
                this.generateCalendar();
            }
            this.prepareStartEndDate();
        },
        searchTerm(newVal, oldVal) {
            if (['this_week', 'next_week'].includes(this.searchType)) {
                this.generateWeekCalendar();
            } else if (['this_month', 'next_month'].includes(this.searchType)) {
                this.generateCalendar();
            }
        },
        'assignOrderData.booking_date': function (newVal, oldVal) {
            this.prepareHandymanOptions();
        },
        'assignOrderData.order_booking_date': function(newVal, oldVal) {
            this.assignOrderData.booking_date = this.formatDate(this.assignOrderData.order_booking_date, 'YYYY-MM-DD') + ' ' + this.assignOrderData.order_booking_time.hours + ':' + this.assignOrderData.order_booking_time.minutes + ':00';
        },
        'assignOrderData.order_booking_time': function(newVal, oldVal) {
            this.assignOrderData.booking_date = this.formatDate(this.assignOrderData.order_booking_date, 'YYYY-MM-DD') + ' ' + this.assignOrderData.order_booking_time.hours + ':' + this.assignOrderData.order_booking_time.minutes + ':00';
        },
        'assignOrderData.assigned_duration_type': function (newVal, oldVal) {
            if (newVal === "full_day") {
                this.assignOrderData.assigned_duration = 8;
            }
        }
    },
};
</script>
<style scoped>
.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.order-list-group-item {
    cursor: move;
}
/*.order-list-group {
    min-height: 100px;
}*/
</style>
